module.exports = __webpack_public_path__ + "static/media/profile_placeholder_5.b2e9fef3.svg";